import pluralize from 'pluralize';
import { Sizes } from '../../enums/sizes';
import { ButtonVariants } from '../../enums/variants';
import { cn } from '../../utils/cn';
import { Button } from './button';

interface CountLinkProps {
  count: number;
  label: string;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

export function CountLink({
  count,
  label,
  onClick,
  className,
}: CountLinkProps) {
  return (
    <Button
      variant={ButtonVariants.LINK_SECONDARY}
      size={Sizes.SM}
      onClick={onClick}
      className={cn(
        'text-utility-blue-600 hover:text-utility-blue-800',
        className
      )}
      disabled={!onClick}
    >
      {count} {pluralize(label, count)}
    </Button>
  );
}
